// Generated by LiveScript 1.6.0
var ref$, id, log, map, filter, head, tail, isItem, pub, sub, MenuModel, out$ = typeof exports != 'undefined' && exports || this;
ref$ = require('utils'), id = ref$.id, log = ref$.log, map = ref$.map, filter = ref$.filter, head = ref$.head, tail = ref$.tail;
isItem = require('./functions').isItem;
ref$ = require('pubsub'), pub = ref$.pub, sub = ref$.sub;
out$.MenuModel = MenuModel = (function(){
  MenuModel.displayName = 'MenuModel';
  var prototype = MenuModel.prototype, constructor = MenuModel;
  function MenuModel(data){
    this.data = data;
  }
  MenuModel.prototype.init = function(data){
    var ref$;
    this.data = data;
    return (ref$ = this.data).categories = ref$.categories.filter(function(it){
      return it.items.length || it.categories.length;
    });
  };
  MenuModel.prototype.getByIndexChain = function(chain, menu){
    var type;
    menu == null && (menu = this.data);
    if (!menu) {
      return null;
    }
    if (isItem(menu) || chain == null || chain.length < 1) {
      return menu;
    }
    type = menu.categories.length > 0 ? 'categories' : 'items';
    if (chain.length === 1) {
      return menu[type][chain[0]];
    } else {
      return this.getByIndexChain(tail(chain), menu[type][head(chain)]);
    }
  };
  MenuModel.prototype.getNameOfNode = function(chain, menu){
    return this.getByIndexChain(chain).name;
  };
  MenuModel.prototype.getCategoryImage = function(chain, menu){
    menu == null && (menu = this.data);
  };
  MenuModel.prototype.findByServdId = function(id, menu){
    var ref$, i$, ref1$, len$, submenu, that, ref2$;
    menu == null && (menu = this.data);
    if (menu.id === id) {
      return menu;
    }
    if (((ref$ = menu.categories) != null ? ref$.length : void 8) > 0) {
      for (i$ = 0, len$ = (ref1$ = menu.categories).length; i$ < len$; ++i$) {
        submenu = ref1$[i$];
        if (that = this.findByServdId(id, submenu)) {
          return that;
        }
      }
    }
    if (((ref1$ = menu.items) != null ? ref1$.length : void 8) > 0) {
      for (i$ = 0, len$ = (ref2$ = menu.items).length; i$ < len$; ++i$) {
        submenu = ref2$[i$];
        if (that = this.findByServdId(id, submenu)) {
          return that;
        }
      }
    }
    return null;
  };
  MenuModel.prototype.resolveRecommendations = function(item, data){
    var resolve, this$ = this;
    data == null && (data = this.data);
    if (item.recommendations != null) {
      resolve = function(it){
        return this$.findByServdId(data, it);
      };
      return item.recommendations = map(function(it){
        return it.name;
      }, filter(id, map(resolve, item.recommendations)));
    }
  };
  return MenuModel;
}());
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1vZGVsLmxzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0EsSUFBQSxHQUF1QyxPQUF2QyxDQUErQyxPQUFBLENBQS9DLEVBQUUsRUFBbUMsQ0FBQSxDQUFBLENBQXJDLElBQUEsQ0FBQSxFQUFBLEVBQU0sR0FBK0IsQ0FBQSxDQUFBLENBQXJDLElBQUEsQ0FBQSxHQUFBLEVBQVcsR0FBMEIsQ0FBQSxDQUFBLENBQXJDLElBQUEsQ0FBQSxHQUFBLEVBQWdCLE1BQXFCLENBQUEsQ0FBQSxDQUFyQyxJQUFBLENBQUEsTUFBQSxFQUF3QixJQUFhLENBQUEsQ0FBQSxDQUFyQyxJQUFBLENBQUEsSUFBQSxFQUE4QixJQUFPLENBQUEsQ0FBQSxDQUFyQyxJQUFBLENBQUE7QUFDRSxNQUFVLENBQUEsQ0FBQSxDQUFFLE9BQWQsQ0FBc0IsYUFBQSxDQUF0QixDQUFBO0FBQ0EsSUFBQSxHQUFlLE9BQWYsQ0FBdUIsUUFBQSxDQUF2QixFQUFFLEdBQVcsQ0FBQSxDQUFBLENBQWIsSUFBQSxDQUFBLEdBQUEsRUFBTyxHQUFNLENBQUEsQ0FBQSxDQUFiLElBQUEsQ0FBQTtpQkFPYSxhQUFOLFFBQUEsQ0FBQTs7O0VBRUwsUUFBQSxDQUFBLFNBQUEsQ0FBQSxJQUFBO0lBQUMsSUFBQyxDQUFBOztzQkFFRixPQUFPLFFBQUEsQ0FBQSxJQUFBOztJQUFDLElBQUMsQ0FBQTttQkFDUCxJQUFDLENBQUEsS0FBSSxDQUFDLGlCQUFELENBQUMsVUFBVyxDQUFHLE9BQU8sUUFBQSxDQUFBLEVBQUE7YUFBRyxFQUFFLENBQUMsS0FBSyxDQUFDLE1BQU8sQ0FBQSxFQUFBLENBQUcsRUFBRSxDQUFDLFVBQVUsQ0FBQztLQUFwQzs7c0JBRTdCLGtCQUFxQixRQUFBLENBQUEsS0FBQSxFQUFBLElBQUE7O0lBQVEsaUJBQUEsT0FBTyxJQUFDLENBQUE7SUFDbkMsSUFBRyxDQUFJLElBQVA7TUFBaUIsTUFBQSxDQUFPLElBQVA7O0lBQ2pCLElBQUcsTUFBYSxDQUFMLElBQUEsQ0FBSyxDQUFBLEVBQUEsQ0FBTyxLQUFKLFFBQVcsQ0FBQSxFQUFBLENBQUcsS0FBSyxDQUFDLE1BQU8sQ0FBQSxDQUFBLENBQUUsQ0FBaEQ7TUFBdUQsTUFBQSxDQUFPLElBQVA7O0lBQ3ZELElBQUssQ0FBQSxDQUFBLENBQUssSUFBSSxDQUFDLFVBQVUsQ0FBQyxNQUFPLENBQUEsQ0FBQSxDQUFFLEVBQUUsRUFBSyxhQUFhLEVBQUs7SUFDNUQsSUFBRyxLQUFLLENBQUMsTUFBTyxDQUFBLEdBQUEsQ0FBRyxDQUFuQjthQUEwQixJQUFJLENBQUMsSUFBRCxDQUFNLENBQUMsS0FBSyxDQUFDLENBQUQsQ0FBTjtLQUNwQzthQUFLLElBQUMsQ0FBQSxnQkFBb0IsS0FBSyxLQUFBLEdBQVEsSUFBSSxDQUFDLElBQUQsQ0FBTSxDQUFDLElBQUQsQ0FBTSxLQUFBLENBQU4sQ0FBeEI7OztzQkFFM0IsZ0JBQW1CLFFBQUEsQ0FBQSxLQUFBLEVBQUEsSUFBQTtXQUNqQixJQUFDLENBQUEsZ0JBQW1CLEtBQUEsQ0FBTSxDQUFDOztzQkFFN0IsbUJBQXFCLFFBQUEsQ0FBQSxLQUFBLEVBQUEsSUFBQTtJQUFRLGlCQUFBLE9BQU8sSUFBQyxDQUFBOztzQkFFckMsZ0JBQW1CLFFBQUEsQ0FBQSxFQUFBLEVBQUEsSUFBQTs7SUFBSyxpQkFBQSxPQUFPLElBQUMsQ0FBQTtJQUM5QixJQUFHLElBQUksQ0FBQyxFQUFHLENBQUEsR0FBQSxDQUFHLEVBQWQ7TUFDRSxNQUFBLENBQU8sSUFBUDs7SUFDRixJQUEyQixDQUFBLENBQUEsSUFBQSxDQUFBLENBQUEsQ0FBeEIsSUFBSSxDQUFDLFVBQW1CLENBQUEsUUFBQSxDQUF4QixFQUF3QixJQUFSLENBQUMsTUFBTyxDQUFBLEVBQUEsTUFBQSxDQUFBLENBQUEsQ0FBQSxDQUFFLENBQTdCO01BQ0UscUVBQUE7UUFBSTtRQUNGLElBQUEsSUFBQSxDQUFBLENBQUEsQ0FBRyxJQUFDLENBQUEsYUFBSixDQUFxQixFQUFyQixFQUF5QixPQUFKLENBQXJCO1VBQ0UsTUFBQSxDQUFPLElBQVA7Ozs7SUFDTixJQUFzQixDQUFBLENBQUEsS0FBQSxDQUFBLENBQUEsQ0FBbkIsSUFBSSxDQUFDLEtBQWMsQ0FBQSxRQUFBLENBQW5CLEVBQW1CLEtBQVIsQ0FBQyxNQUFPLENBQUEsRUFBQSxNQUFBLENBQUEsQ0FBQSxDQUFBLENBQUUsQ0FBeEI7TUFDRSxnRUFBQTtRQUFJO1FBQ0YsSUFBQSxJQUFBLENBQUEsQ0FBQSxDQUFHLElBQUMsQ0FBQSxhQUFKLENBQXFCLEVBQXJCLEVBQXlCLE9BQUosQ0FBckI7VUFDRSxNQUFBLENBQU8sSUFBUDs7OztJQUNOLE1BQUEsQ0FBTyxJQUFQOztzQkFFRix5QkFBMEIsUUFBQSxDQUFBLElBQUEsRUFBQSxJQUFBOztJQUFPLGlCQUFBLE9BQU8sSUFBQyxDQUFBO0lBQ3ZDLElBQUcsSUFBSSxDQUFDLGVBQUwsUUFBSDtNQUNFLE9BQVEsQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEVBQUE7ZUFBRyxLQUFDLENBQUEsY0FBaUIsTUFBTSxFQUFOOzthQUMvQixJQUFJLENBQUMsZUFBZ0IsQ0FBQSxDQUFBLENBQUUsSUFBSyxRQUFBLENBQUEsRUFBQTtlQUFBLEVBQUEsQ0FBQztTQUFPLE9BQU8sSUFBSSxJQUFJLFNBQVMsSUFBSSxDQUFDLGVBQWQsQ0FBUixDQUFoQiIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19

